import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import API from '../api/axios';
import './CertificationStatus.css';

const CertificationStatus = () => {
  const { user } = useContext(AuthContext);
  const [certification, setCertification] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && ['examiner', 'subject_matter_expert', 'moderator'].includes(user.role)) {
      fetchCertificationStatus();
    } else {
      setLoading(false);
    }
  }, [user]);

  const fetchCertificationStatus = async () => {
    try {
      const { data } = await API.get('/faculty-certification/my-certification');
      if (data.success) {
        setCertification(data.certification);
      }
    } catch (err) {
      console.error('Failed to fetch certification status');
    } finally {
      setLoading(false);
    }
  };

  // Don't show for non-faculty roles
  if (!user || !['examiner', 'subject_matter_expert', 'moderator'].includes(user.role)) {
    return null;
  }

  if (loading) {
    return (
      <div className="certification-status loading">
        <div className="certification-spinner"></div>
      </div>
    );
  }

  if (!certification) {
    return null;
  }

  const getCertificationBadge = () => {
    if (certification.is_certified) {
      return (
        <div className="certification-badge university">
          <span className="badge-icon">🎓</span>
          <div className="badge-content">
            <span className="badge-title">University Certified</span>
            <span className="badge-subtitle">Cross-college access</span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="certification-badge department">
          <span className="badge-icon">🏢</span>
          <div className="badge-content">
            <span className="badge-title">Department Level</span>
            <span className="badge-subtitle">College access only</span>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="certification-status">
      {getCertificationBadge()}
      {certification.is_certified && (
        <div className="certification-details">
          <p><strong>Certified by:</strong> {certification.certified_by}</p>
          <p><strong>Date:</strong> {new Date(certification.certified_at).toLocaleDateString()}</p>
        </div>
      )}
    </div>
  );
};

export default CertificationStatus;